import styled from 'styled-components';
import { breakpoints, colors, text, verticalGutter } from '../../styles';

export default styled.dl`
  margin: ${verticalGutter / 2}rem 0;
  &:last-child {
    margin-bottom: 0;
  }
  dt {
    float: left;
  }
  dd {
    text-align: right;
    font-weight: bold;
  }

  dt,
  dd {
    padding: 0.25rem 0;
  }

  /* namespace'd styles */
  &.datalist {
    &--row,
    &--column {
      font-size: ${text.huge};
    }

    &--row {
      dt {
        margin-right: 1rem;
        font-weight: bold;
        color: ${colors.textColor};
      }
      dd {
        text-align: left;
      }
    }

    &--column {
      margin: ${verticalGutter / 2}rem 0;

      &:not(.datalist--huge) {
        dt {
          font-size: ${text.small};
          text-transform: uppercase;
          color: ${colors.grey};
          line-height: 1;
          letter-spacing: 0.025em;
          float: none;
          margin-bottom: ${verticalGutter / 2}rem;
        }
      }

      dd {
        text-align: left;
        line-height: ${text.lineHeight};
      }
    }

    &--huge {
      dt {
        font-weight: bold;
        margin-bottom: ${verticalGutter / 4}rem;
        color: ${colors.textColor};
        float: none;
      }
    }

    &--bold,
    &--bolder {
      margin: ${verticalGutter / 1.5}rem 0;
      font-weight: bold;
      font-size: ${text.massive};

      small {
        display: block;
        font-size: ${text.medium};
        font-weight: normal;
        opacity: 0.8;
        margin: ${verticalGutter / 4}rem 0;
      }

      @media only screen and (min-width: ${breakpoints.tablet}) {
        dt,
        dd {
          display: inline-block;
          vertical-align: top;
          float: none;
        }
      }
    }

    &--bolder {
      dd {
        font-size: 2rem;
        line-height: 1;
      }
    }

    &--tight {
      margin-top: 0 !important;
      margin-bottom: 0 !important;

      dt {
        margin-bottom: 0 !important;
      }
    }

    &--big-font {
      font-size: ${text.big};
    }

    &--pricing {
      dt,
      dd {
        padding: 0.25rem;
      }
      dt {
        margin-right: 0.5rem;
      }
    }

    &--no-bottom-margin {
      margin-bottom: 0 !important;
    }
  }
`;
